export const NOTIFICATION_ERROR_WRITE_FOLDER_PERMISSIONS =
  'folderWritePermission'

export const DOCUMENT_MOVE_TO_ACTION_MODAL_VALIDATION_FIELD_CAN_WRITE =
  'canWrite'
